(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["module-filter-sort"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const filterForm = document.getElementById('CollectionFiltersForm');
    const productContainer = document.getElementById('product-container');
    const paginationContainer = document.getElementById('pagination-container');
    const sortSelect = document.getElementById('sorting');

    const sectionId = filterForm?.dataset.sectionId;
    if (!filterForm || !sectionId || !productContainer) return;

    const fetchFilteredProducts = () => {
      const params = new URLSearchParams(new FormData(filterForm));

      if (sortSelect && sortSelect.value && sortSelect.value !== 'manual') {
        params.set('sort_by', sortSelect.value);
      } else {
        params.delete('sort_by');
      }

      fetch(`${window.location.pathname}?section_id=${sectionId}&${params.toString()}`)
        .then((res) => res.text())
        .then((html) => {
          const tempDOM = document.createElement('div');
          tempDOM.innerHTML = html;

          const newProducts = tempDOM.querySelector('#product-container');
          const newPagination = tempDOM.querySelector('#pagination-container');
          const newProductCount = tempDOM.querySelector('#product-count');

          if (newProducts) productContainer.innerHTML = newProducts.innerHTML;
          if (newPagination) paginationContainer.innerHTML = newPagination.innerHTML;

          window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
        });
    };

    filterForm.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', fetchFilteredProducts);
    });

    filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
      input.addEventListener('change', fetchFilteredProducts);
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', fetchFilteredProducts);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["module-lang-switcher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('localization-form')) {
        customElements.define(
            'localization-form',
            class extends HTMLElement {
                constructor() {
                    super();
                    this.elements = {
                        langInput: this.querySelector('input[name="language_code"]'),
                        countryInput: this.querySelector('input[name="country_code"]'),
                        button: this.querySelector('button[aria-haspopup="listbox"]'),
                        panel: this.querySelector('#langMenu'),
                    };

                    // sanitize return_to: прибрати /xx або /xx-XX
                    const rt = this.querySelector('input[name="return_to"]');
                    if (rt) {
                        const cleanPath = location.pathname.replace(/^\/[a-z]{2}(?:-[A-Z]{2})?(\/|$)/, '/');
                        rt.value = cleanPath + location.search + location.hash;
                    }

                    this.querySelectorAll('#langMenu [role="option"]').forEach((btn) => btn.addEventListener('click', this.onItemClick.bind(this)));

                    this.elements.button?.addEventListener('click', this.togglePanel.bind(this));
                    this.elements.button?.addEventListener('focusout', this.closeOnBlur.bind(this));
                    this.elements.panel?.addEventListener('focusout', this.closeOnBlur.bind(this));
                    this.addEventListener('keyup', this.onKeyUp.bind(this));
                }

                openPanel() {
                    this.elements.panel?.removeAttribute('hidden');
                    this.elements.panel?.classList.remove('opacity-0', 'scale-95', 'pointer-events-none');
                    this.elements.button?.setAttribute('aria-expanded', 'true');
                }
                hidePanel() {
                    this.elements.panel?.setAttribute('hidden', true);
                    this.elements.panel?.classList.add('opacity-0', 'scale-95', 'pointer-events-none');
                    this.elements.button?.setAttribute('aria-expanded', 'false');
                }
                togglePanel() {
                    const expanded = this.elements.button?.getAttribute('aria-expanded') === 'true';
                    expanded ? this.hidePanel() : this.openPanel();
                }
                closeOnBlur(e) {
                    const to = e.relatedTarget;
                    const inside = to && this.contains(to);
                    if (!inside) this.hidePanel();
                }
                onKeyUp(e) {
                    if (e.code?.toUpperCase() === 'ESCAPE' && this.elements.button?.getAttribute('aria-expanded') === 'true') {
                        this.hidePanel();
                        e.stopPropagation();
                        this.elements.button?.focus();
                    }
                }
                onItemClick(e) {
                    e.preventDefault();
                    const iso = e.currentTarget.dataset.value;
                    const form = this.querySelector('form');

                    if (iso === this.elements.langInput?.value) {
                        this.hidePanel();
                        return;
                    }

                    if (this.elements.langInput) this.elements.langInput.value = iso;
                    form?.submit();
                }
            }
        );
    }
  } catch(e) { console.error(e); }
})();

})();
